export default {"src":"/_next/static/image/public/assets/icons/performance.e4a3f548dd489bc786d2291c56869da5.svg","height":20,"width":20};